module.exports = __webpack_public_path__ + "static/cs33-35db095983f3d2a8ac5a3526371f4ba4.jpg";